<template>
  <tr>
    <td class="pl-0 py-6">
      <button
        class="btn btn-icon btn-light btn-hover-primary btn-sm"
        @click="remove"
      >
        <span
          class="svg-icon svg-icon-md svg-icon-primary"
          v-b-tooltip.topleft
          v-b-tooltip.hover
          :title="'Remove from campaign'"
        >
          <!--begin::Svg Icon | path:assets/media/svg/icons/General/Trash.svg-->
          <inline-svg src="media/svg/icons/General/Trash.svg"> </inline-svg>
          <!--end::Svg Icon-->
        </span>
      </button>
    </td>
    <td class="pl-0 py-6">
      <span class="text-muted font-weight-bold">
        <a
          class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
          href="#"
          ><img width="32" :src="product.logo" />
          {{ product.productName }}
        </a>
      </span>
    </td>
    <td>
      <span class="text-dark-75 d-block font-size-lg">
        {{ product.productType }}
      </span>
    </td>
    <td>
      <span
        class="text-dark-75 d-block font-size-lg"
        v-if="vonqPrice.amount > 0"
      >
        {{ currency.symbol }}{{ priceFormat(vonqPrice.amount) }}
      </span>
    </td>
    <td>
      <span class="text-dark-75 d-block font-size-lg">
        {{ product.daysToProcess }} days
      </span>
    </td>
  </tr>
</template>

<script>
import ProductMixin from "@/view/mixins/ProductMixin";
import PriceMixin from "@/view/mixins/PriceMixin";

export default {
  name: "BasketProduct",
  props: {
    product: Object,
    currency: Object
  },
  mixins: [ProductMixin, PriceMixin],
  emits: ["remove"],
  methods: {
    remove() {
      this.$emit("remove", this.product.productId);
    }
  }
};
</script>
